import { Map, fromJS } from "immutable";
import { USER_LOGIN_SUCCESS } from "./actions";

export default function Login(state = Map(), action) {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
      return state.set("profile", fromJS(action.data));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/screens/Login/redux/reducer.js